<template>
  <div class="mb-12">
    <div class="text-lg font-bold text-text leading-tight mb-4 flex items-center cursor-pointer"
         @click="showGroup = !showGroup">
      {{ groupName }}
      <IconChevronSm class="transform ml-4 text-text-ternary transition duration-200"
                     :class="{'-rotate-180':showGroup}"/>
    </div>
    <TransitionCollapseHeight>
      <div class="divide divide-y divide-line" v-show="showGroup">
        <slot/>
      </div>
    </TransitionCollapseHeight>
  </div>
</template>

<script>
import TransitionCollapseHeight from "@/components/transitions/TransitionCollapseHeight";
import IconChevronSm from "@/components/icons/IconChevronSm";

export default {
  name: "TicketsFAQGroup",
  components: {IconChevronSm, TransitionCollapseHeight},
  props: {
    groupName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showGroup: true
    }
  }
}
</script>